const { BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME, BROKER_CUSTOM_WALLET_GENERAL_VIEW } = require('../constants/index');
const { formatText } = require('core/i18n').i18n;

const { parsePortfolioDTO } = require('./brokerCustomWalletParseHelper');

const parsePortfolio = (portfolio) => {
    const parsedPortfolio = parsePortfolioDTO(portfolio);
    const parsedPortfolioUpperCaseName = parsedPortfolio.descriptionPortfolioAccount;

    parsedPortfolio.contracts = [];
    parsedPortfolio.alreadyMergedContracts = false;
    parsedPortfolio.isContractResquestError = false;
    parsedPortfolio.isEditable = portfolio.typePortfolioAccount !== BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME;
    parsedPortfolio.editionMode = false;

    if (parsedPortfolioUpperCaseName === BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME) {
        parsedPortfolio.descriptionPortfolioAccount = parsedPortfolioUpperCaseName;
    }

    return parsedPortfolio;
}

const parsePortfolios = portfolios => {
    const orderedPortfolios = portfolios.sort(
        (a, b) => a.descriptionPortfolioAccount.localeCompare(b.descriptionPortfolioAccount));

    //General or Total View
    orderedPortfolios.unshift({
        descriptionPortfolioAccount: formatText('brokerCustomWallet-allPortfolios'),
        idCartera:"",
        idPortfolioAccount: Number(BROKER_CUSTOM_WALLET_GENERAL_VIEW),
        idTypePortfolioAccount:3,
        portfolioId:"",
        typePortfolioAccount: BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME,
        userId:"",
        defaultView: true,
        count: 0
    });

    return orderedPortfolios.map((portfolio) => {
        return parsePortfolio(portfolio);
    });
}

module.exports = {
    parsePortfolios,
    parsePortfolio
};
